import React from 'react';

export const TrashSvg = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3 7L3.00001 12C3.00001 12.5523 3.44772 13 4.00001 13H10C10.5523 13 11 12.5523 11 12L11 7"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.3125 4.0625H12.6875"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4 4.0625V2C4 1.44772 4.44772 1 5 1H9C9.55228 1 10 1.44772 10 2V4.0625"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
